import { Grid, IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';
import {
  HeaderDiv,
  HeaderDivContainer,
  HeaderTitle,
  VideoContainer,
  GuideBtnContainer,
  GuideBtn,
  GuideBtnText,
} from '../LandingPage.Styled';
import CustomDialogWrapper from '../../../components/UI/CustomDialogWrapper/CustomDialogWrapper';
import CustomVideoPlayer from '../../../components/UI/CustomVideoPlayer';
import { Guide } from '../../../assets/images/landing-screen';

interface UserGuideDialogProps {
  open: boolean;
  onClose: () => void;
  videoUrl: string;
  loading: boolean;
  error: string | null;
}

const UserGuideDialog: React.FC<UserGuideDialogProps> = ({ open, onClose, videoUrl, loading, error }) => {
  const handleDownload = (val: any) => {};

  return (
    <CustomDialogWrapper open={open} onClose={onClose} width="1000px">
      <Grid>
        <HeaderDiv>
          <HeaderDivContainer>
            <img src={Guide} alt="Guide" />
            <HeaderTitle>User Guide</HeaderTitle>
          </HeaderDivContainer>
          <IconButton
            onClick={onClose}
            sx={{
              color: 'white',
              paddingRight: '20px',
              '&:hover': {
                backgroundColor: 'transparent',
              },
            }}
          >
            <Close />
          </IconButton>
        </HeaderDiv>
        <VideoContainer>
          <CustomVideoPlayer videoUrl={videoUrl} loading={loading} error={error} />
        </VideoContainer>
        <GuideBtnContainer>
          <GuideBtn onClick={() => handleDownload('document-1')}>
            <GuideBtnText>Guide Document 1</GuideBtnText>
          </GuideBtn>
          <GuideBtn
            onClick={() => handleDownload('document-2')}
            sx={{
              marginLeft: '10px',
            }}
          >
            <GuideBtnText>Guide Document 2</GuideBtnText>
          </GuideBtn>
        </GuideBtnContainer>
      </Grid>
    </CustomDialogWrapper>
  );
};

export default UserGuideDialog;
